import type { RequestConfig } from '@customTypes/index';
import type { ArtistJobs, WorkItemStatus } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type AdminUpdateWorkItemRequest = {
  workRequestId?: number;
  workInviteId?: number;
  status?: WorkItemStatus;
  startDate?: string;
  endDate?: string;
  ticketCreditation?: boolean;
  arrivalConfirmed?: boolean;
  jobRole?: ArtistJobs;
};

export type AdminUpdateWorkItemParams = RequestConfig<AdminUpdateWorkItemRequest>;

export const adminUpdateWorkItem = async ({ params, config }: AdminUpdateWorkItemParams) =>
  api.put('/api/work/admin/update-work-item', params, config);
